
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class DimIndexationProfileGrid extends Serenity.EntityGrid<DimIndexationProfileRow, any> {
        protected getColumnsKey() { return DimIndexationProfileColumns.columnsKey; }
        protected getDialogType() { return DimIndexationProfileDialog; }
        protected getIdProperty() { return DimIndexationProfileRow.idProperty; }
        protected getInsertPermission() { return DimIndexationProfileRow.insertPermission; }
        protected getLocalTextPrefix() { return DimIndexationProfileRow.localTextPrefix; }
        protected getService() { return DimIndexationProfileService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}